import moment from 'moment-timezone'

import { getInitialCustomDuration, isCustomEventDuration } from 'components/event_type_edit'

const locationPayload = (locationConfigurations) => {
  const locationConfiguration = locationConfigurations[0] || {}
  const {
    kind,
    location,
    phone_number: phoneNumber,
    additional_info: additionalInfo
  } = locationConfiguration

  const locationDetails = () => {
    switch (kind) {
      case 'physical':
        return { physicalAddress: location, physicalDetails: additionalInfo }
      case 'inbound_call':
        return { phoneNumber, phoneDetails: additionalInfo }
      case 'custom':
        return { customLocation: location }
      default:
        return {}
    }
  }

  return { location: kind, ...locationDetails(), locationConfigurations }
}

export const buildEditPollState = (state, eventType) => {
  const {
    name,
    timezone,
    duration,
    spots,
    memberships,
    id: eventTypeId,
    uuid: eventTypeUuid,
    locale: inviteeLocale,
    description: details,
    votes_visible: votesVisible,
    reserve_times: reserveTimes,
    location_configurations: locationConfigurations,
  } = eventType

  const colorIndexes = state.availabilityStep.hostsField.colorIndexes
  const isCustomDuration = isCustomEventDuration(duration)

  const selectedSpots = spots.map((spot) => ({
    current: true,
    start: moment(spot.start_time),
    end: moment(spot.end_time),
    invitees: spot.invitees
  }))

  const dateRangeStart = selectedSpots[0]?.start.clone()

  const selectedMembers = memberships.map((host, idx) => ({
    ...host,
    colorIndex: colorIndexes[idx],
    eventsLoadStatus: 'pending',
    availabilityRules: host.availability_rules
  }))

  return {
    ...state,
    loading: false,
    eventTypeId,
    eventTypeUuid,
    detailsStep: {
      ...state.detailsStep,
      votesVisible,
      notifyInvitees: true,
      fields: {
        ...state.detailsStep.fields,
        name,
        details,
        inviteeLocale,
        ...locationPayload(locationConfigurations),
      }
    },
    availabilityStep: {
      ...state.availabilityStep,
      timezone,
      dateRangeStart,
      selectedSpots,
      reserveTimes,
      fetchInitialEvents: true,
      eventTypeDuration: duration,
      durationField: {
        ...state.availabilityStep.durationField,
        duration: !isCustomDuration ? duration.toString() : 'custom',
        customDurationValue: getInitialCustomDuration(isCustomDuration, duration),
        customDurationUnit: isCustomDuration && duration % 60 === 0 ? 'hours' : 'minutes'
      },
      hostsField: {
        ...state.availabilityStep.hostsField,
        selectedMembers,
        colorIndexes: colorIndexes.filter((colorIdx) => (
          !selectedMembers.map(({ colorIndex }) => colorIndex).includes(colorIdx)
        ))
      }
    }
  }
}
